import React,{ useState, useEffect} from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch, connect} from 'react-redux';
import Radio from '@material-ui/core/Radio';
import { Divider, Loader, Modal, Button  } from 'rsuite';
import {generateAddressString}  from '../../../../app/common/services/vehicle.service';
import * as actionsPolicy  from '../../../../app/actions/policy';
import * as actionsUser  from '../../../../app/actions/user';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon, CirclePlusIcon} from '../svg/iconsSvg';
import NewAddress from './NewAddress';
import CustomDrawer from '../../../pages/components/elements/CustomDrawer';


const OwnerAddress = ({onBack, onForward, updateOwnerDetails, setGoToLiability, style}) => {

    const dispatch = useDispatch();
    const history = useHistory();
    
    const auth = useSelector(state => state.auth);

    const {ownerAddress}               = useSelector(state => state.ownerDetails);
    const {userAddresses, userAddress} = useSelector(state => state.userDetails) || {};

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(auth?.loginToken);

    const [showNoAddressModal, setShowNoAddressModal] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [showLoggin, setShowLoggin] = useState(false);
    const [addressAdded, setAddressAdded] = useState(false);

    useEffect(() => {
        if(auth?.loginToken) {
            setLoggedIn(true);
        } else {
            setLoggedIn(false);
        }
    }, [auth]);

    useEffect(()=>{
        const fetchUserAddresses = async () => {
            setLoading(true);
            await dispatch(actionsUser.getUserAddresses());
            setLoading(false);
        }

        if(loggedIn) {
            if(!userAddresses) {
                fetchUserAddresses();
            }
        }
    }, [userAddresses, userAddress, loggedIn, dispatch]);

    useEffect(() => {
        const addAddress = async () => {
            setLoading(true);
            await dispatch(actionsPolicy.addOwnerAddress(ownerAddress));
            setLoading(false);
        }

        if(auth?.loginToken && userAddresses && ownerAddress && !ownerAddress?.addressId) {
                if(!addressAdded ) {
                    addAddress(); // this is used when user logged in after redirected from this screen
                    setAddressAdded(true);
                }
        } 
    }, [auth, userAddresses, ownerAddress, dispatch, addressAdded]);

    const selectOwnerAddress = (addressId) => {
        const address = userAddresses.find(address=>address.addressId === addressId);
        updateOwnerDetails({ownerAddress: address});
    }

    const closeModal = () => setShowNoAddressModal(false);

    const addAddress = (event) => {
        event.stopPropagation();
        setShowDrawer(true);
    }

    const closeDrawer = () => {
        setShowDrawer(false);
    }

    const onCancel = () => setShowLoggin(false);

    const continueWithSignUp = () => submitHandler();

    const goToLogin = () => {
        setGoToLiability(true);
        history.push('/app/profile');
    }

    const submitHandler = () => {
        if(ownerAddress) {
            const nextStep = loggedIn ? 13 : 10;
            const backTo = loggedIn ? 9 : null;
            onForward(nextStep, backTo);
        } else {
            setShowNoAddressModal(true);
        }
    }

    const onNewAddressSubmit = async (newAddress) => {
        //console.log(newAddress);
        closeDrawer();
        setLoading(true);
        if(loggedIn) {
            await dispatch(actionsPolicy.addOwnerAddress(newAddress));
            setLoading(false);
        } else {
            setLoading(false);
            if(!ownerAddress) {
                await dispatch(actionsPolicy.updateOwnerDetails({ownerAddress: newAddress}));
            }
            setShowLoggin(true);
            //setTimeout(()=> submitHandler(), 0);
        }
    }

    const goBack = () => {
        onBack(8)
    }

    const renderUserAddresses = () => {
       // console.log(userAddresses)

        if(userAddresses) {
            userAddresses.sort((a, b)=> {
                if(b.isUserAddress) return 1;
                else return -1;
            });
            return userAddresses.map((address, i) => {
                return (
                    <div key={i+1}>
                        <div className="steps_container-checkbox" style={{alignItems: 'start', paddingLeft: '23px'}}>
                            <Radio
                                checked={address.addressId === ownerAddress?.addressId}
                                onChange={()=>selectOwnerAddress(address.addressId)}
                                value=""
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B'+ i }}
                                />
                            <div style={{margin: '8px 0'}}>
                                {address.isUserAddress &&
                                    <h6 style={{margin: '0 0 8px',fontWeight: '500', color: '#0b2743'}}>Използвай моя адрес</h6>
                                }
                                <p>{generateAddressString(address)}</p>
                            </div>
                        </div>
                        <Divider />
                    </div>)
            });
        }

        return null;
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={3} steps={4} labels={steppLabels}/>
            </div>
            <Divider />
            <h6 style={{paddingLeft:"2rem", fontWeight: '500', color: '#0b2743', marginTop: '8px', marginBottom: '38px'}}>Адрес на собственика по талон </h6>
           
            {loggedIn
                ? <>
                    <Divider />
                    {renderUserAddresses()}
                    <div className="steps_container-checkbox"  style={{cursor: 'pointer', marginBottom: '38px'}} onClick={addAddress}>
                        <CirclePlusIcon size={22} />
                        <h6 style={{marginLeft: '10px', fontWeight: '500'}}>Добавяне на нов адрес</h6>
                    </div>
                  
                    <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={submitHandler}>Продължи</button>
                   
                </>
                :  <NewAddress onSubmit={onNewAddressSubmit} initAddress={ownerAddress} noAddInfo={true}/>
            }
            
            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

        {/* ------Custom drawer for new address-------- */}
            <CustomDrawer show={showDrawer} close={closeDrawer} headerText="Адрес собственика">
                <NewAddress onSubmit={onNewAddressSubmit} noAddInfo={true}/>
            </CustomDrawer>          

            {/* Modal for no owner address */}
            <Modal size="xs" show={showNoAddressModal} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data" style={{letterSpacing: '.04em'}}>Избери адрес</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
            {/* Loggin modal */}
            <Modal size="xs" className="nuins-choose-modal" show={showLoggin} onHide={() => onCancel()}>
                <Modal.Body>
                    <p className="no-reg-data">Влезте в съществуващ профил или продължете с нова регистрация</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onCancel()} >Cancel</Button>
                    <Button onClick={() => goToLogin()} >Влез в профил</Button>
                    <Button onClick={() => continueWithSignUp()} active>Създай профил</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default connect(null, {...actionsPolicy})(OwnerAddress);